/* eslint-disable jsx-a11y/anchor-is-valid */
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import globalStyles from "../../assets/styles/base/globalPage.module.scss";
import { pathConstants } from "../../routes/pathContants";

export const SmsCampaignLayout = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const campaignTypes = [
    {
      name: "Recommended",
      id: "automated",
      pathName: pathConstants.MARKETING_SMS_CAMPAIGNS_AUTOMATED,
    },
    {
      name: "Custom",
      id: "custom",
      pathName: pathConstants.MARKETING_SMS_CAMPAIGNS_CUSTOM,
    },
  ];

  return (
    <div className={`${globalStyles.pageColumnGaps}`}>
      <div>
        <h4>SMS Campaign</h4>
        <p>Manage, track and optimize your SMS marketing efforts</p>
      </div>

      <div className={globalStyles.rowNavigations}>
        {campaignTypes?.map((item, index) => (
          <a
            key={index}
            className={`${globalStyles.rowNavigations__item} ${
              pathname.includes(item?.pathName) ? globalStyles.active : ""
            }`}
            onClick={() => navigate(item?.pathName)}
          >
            {item?.name}
          </a>
        ))}
      </div>

      <Outlet />
    </div>
  );
};
